module.exports = __webpack_public_path__ + "static/media/m-blog-5.85515b5a.jpg";